import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m432-480 156 156q11 11 11 28t-11 28-28 11-28-11L348-452q-6-6-8.5-13t-2.5-15 2.5-15 8.5-13l184-184q11-11 28-11t28 11 11 28-11 28z" }, null, -1)
  ])))
}
export default { render: render }